import React, { Component } from "react";
// import styled from 'styled-components'
import PropTypes from "prop-types";
import { withFirebase } from "../Firebase";
import { withRouter } from "react-router";
/* Redux imports */
import { connect } from "react-redux";
import { searchActions, searchSelectors } from "../../store/search";
import { schoolSelectors } from "../../store/school";
import { chatActions } from "../../store/chat";
/* styled-component imports */
import { Box, Card, Flex, Text } from "rebass";
/* custom styled-components */
import FacultyNameCard from "../Cards/FacultyNameCard";
import { FacultyProfileCard } from "../Cards";
import { PrimaryButton } from "../Base/Buttons";
import IosArrowBack from "react-ionicons/lib/IosArrowBack";
import FacultyContactMethod from "../Modals/FacultyContactMethod";

import { SectionHeading, Wrapper } from "./styles";

class FacultySummary extends Component {
  state = {
    leaves: null,
    wave: null,
    contactPopup: false,
  };

  handleContact = async () => {
    const {
      firebase,
      student,
      profile,
      isFaculty,
      history,
      updateCurrentChat,
    } = this.props;
    let status = 0;
    if (isFaculty) {
      status = 1;
    }
    let accepted = {
      status: status,
      updated_at: Math.floor(Date.now() / 1000),
    };

    const members = [profile.id, student.id];

    const result = await this.checkIfExists(members);

    if (result !== true) {
      let newChatRef = firebase.chats().doc();
      newChatRef.set({
        creator_uid: profile.id,
        is_group: false,
        members: members,
        post_time: Math.floor(Date.now() / 1000),
        last_updated: Math.floor(Date.now() / 1000),
        messages: [],
        accepted,
        name: "",
      });
      updateCurrentChat(newChatRef.id);
      history.push(`/app/chat`);
    }
  };

  checkIfExists = async (members) => {
    const { firebase, history, updateCurrentChat } = this.props;
    try {
      let chatQuery = await firebase
        .chats()
        .where("members", "==", members)
        .where("is_group", "==", false)
        .get();
      console.log("chatquery", chatQuery);
      if (chatQuery.docs.length > 0) {
        updateCurrentChat(chatQuery.docs[0].id);
        history.push(`/app/chat`);
        // history.push(`/app/chat/${chatQuery.docs[0].id}`);
        return true;
      } else {
        chatQuery = await firebase
          .chats()
          .where("members", "==", members.reverse())
          .where("is_group", "==", false)
          .get();
        if (chatQuery.docs.length > 0) {
          updateCurrentChat(chatQuery.docs[0].id);
          history.push(`/app/chat`);
          return true;
        }
      }
    } catch (err) {
      console.log(err);
    }
    return false;
  };

  toggleContact = () => {
    const { contactPopup } = this.state;
    this.setState({ contactPopup: !contactPopup });
  };

  render() {
    const {
      student,
      showBack,
      handleBack
    } = this.props;

    return (
      <Wrapper width={1}>
        {student === null ? (
          <Flex
            p={6}
            width={1}
            flexWrap={"wrap"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Text m={6} textAlign={"center"}>
              Select a faculty to view details
            </Text>
          </Flex>
        ) : (
          <Flex flexDirection={"column"} width={1} flexWrap={"wrap"}>
            <Card boxShadow={"inset"} width={"100%"} p={2}>
              <Flex>
                {showBack && (
                  <Box mx={3} pt={3} onClick={handleBack}>
                    <PrimaryButton bg={"gray"} color={"white"}>
                      <IosArrowBack size={"20px"} color={"white"} />
                    </PrimaryButton>
                  </Box>
                )}
                <Box>
                  <FacultyNameCard
                    noBorder
                    withLocation
                    details={student}
                    studentSummary
                  />
                </Box>
                <Box ml={"auto"} />
                <Box mr={3}>
                  <FacultyContactMethod
                    profile={student}
                    handleChat={this.handleContact}
                  />
                </Box>
              </Flex>
            </Card>
            <Box width={1} p={3} pt={4}>
              <Flex
                flexDirection={"row"}
                flexWrap={"wrap"}
                justifyContent={"center"}
                p={2}
              >
                <Box width={1 / 3} p={2} css={{ minWidth: "300px" }}>
                  <SectionHeading>
                    {student.first_name}'s Profile
                  </SectionHeading>
                  <Card boxShadow={"inset"} pt={4} p={2}>
                    <FacultyProfileCard
                      profile={student}
                      firebase={this.props.firebase}
                      currentUser={this.props.profile}
                    />
                  </Card>
                </Box>
              </Flex>
            </Box>
          </Flex>
        )}
      </Wrapper>
    );
  }
}

FacultySummary.propTypes = {
  showBack: PropTypes.bool,
  handleBack: PropTypes.func,
  student: PropTypes.object,
  handleRefresh: PropTypes.func,
  rosterView: PropTypes.bool,
  handleRemove: PropTypes.func,
};

FacultySummary.defaultProps = {
  showBack: false,
  handleBack: () => console.log("back"),
  student: { id: 0, wave: [], leaves: [] },
  handleRefresh: () => console.log("refresh"),
  rosterView: false,
  handleRemove: () => console.log("remove"),
};

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
  search: searchSelectors.refreshSearch(state.search),
  filters: searchSelectors.refreshFilters(state.search),
  students: searchSelectors.refreshCurrentResults(state.search),
});

const mapDispatchToProps = (dispatch) => ({
  updateSearch: (term) => {
    dispatch(searchActions.updateSearch(term));
  },
  clearSearch: () => {
    dispatch(searchActions.clearSearch());
  },
  updateStudents: (students) => {
    dispatch(searchActions.updateStudents(students));
  },
  updateCurrentChat: (id) => {
    dispatch(chatActions.updateCurrentChat(id));
  },
});

export default withRouter(
  withFirebase(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(FacultySummary)
  )
);
